module.exports = __webpack_public_path__ + "static/media/liftRocketLogo2.952aa4c6.svg";